// import React, { useState, useCallback } from 'react';
// import UserPool from '../UserPool';


// let logoutTimer;


// const AuthContext = React.createContext({
//   token: '',
//   isLoggedIn: true,
//   login: (token) => {},
//   logout: () => {},
// });

// // const calculateRemainingTime = (expirationTime) => {
// //   const currentTime = new Date().getTime();
// //   const adjExpirationTime = new Date(expirationTime).getTime();

// //   const remainingDuration = adjExpirationTime - currentTime;

// //   return remainingDuration;
// // };

// const retrieveStoredToken = () => {
// //   const storedToken = localStorage.getItem('token');
// //   const storedExpirationDate = localStorage.getItem('expirationTime');

// //   const remainingTime = calculateRemainingTime(storedExpirationDate);

// // //   if (remainingTime <= 3600) {
// // //     localStorage.removeItem('token');
// // //     localStorage.removeItem('expirationTime');
// // //     return null;
// // //   }




// const user = "CognitoIdentityServiceProvider."+UserPool.getClientId()+".LastAuthUser";
// const userDetails = localStorage.getItem(user);
// const tokenItem = "CognitoIdentityServiceProvider."+UserPool.getClientId()+"."+userDetails+".accessToken";
// const storedToken = localStorage.getItem(tokenItem);


//   return {
//     token: storedToken
//   };
// };

// export const AuthContextProvider = (props) => {
//   const tokenData = retrieveStoredToken();
  
//   let initialToken;
//   if (tokenData) {
//     initialToken = tokenData.token;
//   }

//   const [token, setToken] = useState(initialToken);

//   const userIsLoggedIn = !!token;

//   const logoutHandler = useCallback(() => {

//     const user = "CognitoIdentityServiceProvider."+UserPool.getClientId()+".LastAuthUser";
//     const userDetails = localStorage.getItem(user);
//     const tokenItem = "CognitoIdentityServiceProvider."+UserPool.getClientId()+"."+userDetails;
//     localStorage.removeItem("CognitoIdentityServiceProvider."+UserPool.getClientId()+".LastAuthUser");
//     localStorage.removeItem(tokenItem+".clockDrift");
//     localStorage.removeItem(tokenItem+".idToken");
//     localStorage.removeItem(tokenItem+".refreshToken");
//     localStorage.removeItem(tokenItem+".accessToken");
//     window.location.href="/";
//   }, []);

//   const loginHandler = (token, expirationTime) => {

//     const user = "CognitoIdentityServiceProvider."+UserPool.getClientId()+".LastAuthUser";
//     const userDetails = localStorage.getItem(user);
//     const tokenItem = "CognitoIdentityServiceProvider."+UserPool.getClientId()+"."+userDetails+".accessToken";
//     token = localStorage.getItem(tokenItem);
  
//     setToken(token);
//     // localStorage.setItem('token', token);
//     // localStorage.setItem('expirationTime', expirationTime);

//     // const remainingTime = calculateRemainingTime(expirationTime);

//     // logoutTimer = setTimeout(logoutHandler, remainingTime);
//   };

// //   useEffect(() => {
// //     if (tokenData) {
// //       console.log(tokenData.duration);
// //       logoutTimer = setTimeout(logoutHandler, tokenData.duration);
// //     }
// //   }, [tokenData, logoutHandler]);

//   const contextValue = {
//     token: token,
//     // isLoggedIn: userIsLoggedIn,
//     isLoggedIn: true,





//     login: loginHandler,
//     logout: logoutHandler,
//   };

// //   console.log(contextValue)

//   return (
//     <AuthContext.Provider value={contextValue}>
//       {props.children}
//     </AuthContext.Provider>
//   );
// };

// export default AuthContext;



import React, { useState, useCallback, useEffect } from 'react';

const AuthContext = React.createContext({
  token: '',
  isLoggedIn: false,
  login: (username, password) => {},
  logout: () => {},
  error: '',
  user: null
});

// Function to calculate remaining time for token expiration
const calculateRemainingTime = (expirationTime) => {
  const currentTime = new Date().getTime();
  const adjExpirationTime = new Date(expirationTime).getTime();
  const remainingDuration = adjExpirationTime - currentTime;
  return remainingDuration;
};

// Function to get token and expiration from localStorage
const retrieveStoredToken = () => {
  const storedToken = localStorage.getItem('authToken');
  const storedExpirationDate = localStorage.getItem('tokenExpiration');
  const storedUser = localStorage.getItem('authUser');

  if (!storedToken || !storedExpirationDate) {
    return null;
  }

  const remainingTime = calculateRemainingTime(storedExpirationDate);

  // If token is expired (less than 1 minute remaining), remove it
  if (remainingTime <= 60000) {
    localStorage.removeItem('authToken');
    localStorage.removeItem('tokenExpiration');
    localStorage.removeItem('authUser');
    return null;
  }

  return {
    token: storedToken,
    duration: remainingTime,
    user: storedUser ? JSON.parse(storedUser) : null
  };
};

let logoutTimer;

export const AuthContextProvider = (props) => {
  // Hardcoded credentials
  const ADMIN_USERNAME = 'admin';
  const ADMIN_PASSWORD = 'nathan';

  // Initialize token from localStorage
  const tokenData = retrieveStoredToken();
  const [token, setToken] = useState(tokenData ? tokenData.token : null);
  const [user, setUser] = useState(tokenData ? tokenData.user : null);
  const [error, setError] = useState('');

  const userIsLoggedIn = !!token;

  const logoutHandler = useCallback(() => {
    // Clear logout timer
    if (logoutTimer) {
      clearTimeout(logoutTimer);
    }

    // Remove all auth data from localStorage
    localStorage.removeItem('authToken');
    localStorage.removeItem('tokenExpiration');
    localStorage.removeItem('authUser');
    
    // Clear state
    setToken(null);
    setUser(null);
    setError('');
    
    // Redirect to login page
    window.location.href = "/login";
  }, []);

  const loginHandler = useCallback((username, password) => {
    // Clear any previous errors
    setError('');

    // Check hardcoded credentials
    if (username === ADMIN_USERNAME && password === ADMIN_PASSWORD) {
      // Generate a simple token and expiration time (8 hours from now)
      const simpleToken = 'admin_token_' + Date.now();
      const expirationTime = new Date(new Date().getTime() + (8 * 60 * 60 * 1000)); // 8 hours
      
      // User object
      const userData = {
        username: 'admin',
        role: 'Administrator',
        loginTime: new Date().toISOString()
      };
      
      // Store in localStorage
      localStorage.setItem('authToken', simpleToken);
      localStorage.setItem('tokenExpiration', expirationTime.toISOString());
      localStorage.setItem('authUser', JSON.stringify(userData));
      
      // Update state
      setToken(simpleToken);
      setUser(userData);
      
      // Set automatic logout timer for token expiration
      const remainingTime = calculateRemainingTime(expirationTime.toISOString());
      logoutTimer = setTimeout(logoutHandler, remainingTime);
      
      return true;
    } else {
      setError('Invalid username or password');
      return false;
    }
  }, [ADMIN_USERNAME, ADMIN_PASSWORD, logoutHandler]);

  // Set up automatic logout on component mount if token exists
  useEffect(() => {
    if (tokenData) {
      logoutTimer = setTimeout(logoutHandler, tokenData.duration);
    }
    
    return () => {
      if (logoutTimer) {
        clearTimeout(logoutTimer);
      }
    };
  }, [tokenData, logoutHandler]);

  // Function to check if token is still valid
  const isTokenValid = useCallback(() => {
    const storedExpirationDate = localStorage.getItem('tokenExpiration');
    if (!storedExpirationDate) {
      return false;
    }
    
    const remainingTime = calculateRemainingTime(storedExpirationDate);
    return remainingTime > 60000; // Valid if more than 1 minute remaining
  }, []);

  // Function to refresh token (extend session)
  const refreshToken = useCallback(() => {
    if (!token) return false;
    
    // Extend expiration by 8 hours
    const newExpirationTime = new Date(new Date().getTime() + (8 * 60 * 60 * 1000));
    localStorage.setItem('tokenExpiration', newExpirationTime.toISOString());
    
    // Clear existing timer and set new one
    if (logoutTimer) {
      clearTimeout(logoutTimer);
    }
    
    const remainingTime = calculateRemainingTime(newExpirationTime.toISOString());
    logoutTimer = setTimeout(logoutHandler, remainingTime);
    
    return true;
  }, [token, logoutHandler]);

  const contextValue = {
    token: token,
    isLoggedIn: userIsLoggedIn,
    user: user,
    login: loginHandler,
    logout: logoutHandler,
    error: error,
    isTokenValid: isTokenValid,
    refreshToken: refreshToken
  };

  return (
    <AuthContext.Provider value={contextValue}>
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContext;